import Handsontable from 'handsontable'

export function contractorNameRenderer(instance, td, row, col, prop, value, cellProperties, self) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                          //When accessing original array
  let contractor = self.contractors[pRow]
  td.style.color = 'blue'
  td.classList.add('order-num-txt')

  td.onclick = () => {
    self.$router.push({ path: '/excel-contractors/'+contractor.id})
  }
}

export function addressRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.innerHTML = '<p class="address-txt">'+value+'</p>'
  td.children[0].setAttribute('title', value);

}
export function routesRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let title = value.map(r => r.fromCity + ' - ' + r.toCity).join('<br>')

  const tdPosition = td.getBoundingClientRect();
  // console.log('cell', tdPosition)
  let top = tdPosition.top;
  let left = tdPosition.left;

  td.innerHTML = `<div class="poptip"><div class="poptip-rel">${value.length || '-'}</div>
                                      <div class="popper" style="top:${top};left:${left}">${title}</div></div>`
  // td.setAttribute('title', title || 'NA')
  td.style.cursor = 'pointer'
}

export function statusRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.innerHTML = value?'Active':'Inactive';
  td.style.color = value?'#3FB716':'red';
}
export function sendSMSRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.innerHTML = value?'ON':'OFF';
  td.style.color = value?'#3FB716':'red';
}

export function clientStatusRenderer(instance, td, row, col, prop, value, cellProperties, self, array) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  let pRow = instance.toPhysicalRow(row)                          //When accessing original array
  let record = self[array][pRow];
  if(value){
    td.innerHTML = 'Active';
    td.style.color ='#3FB716';
  }else if(record.isRejected){
    td.innerHTML = 'Inactive';
    td.style.color = 'red';
  }else{
    td.innerHTML = 'Pending';
    td.style.color = 'orange';
  }
}

export function tempoOrderStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.style.color = value === 'Active'?'orange':'green';
}

export function actionRenderer(instance, td, row, col, prop, value, cellProperties, self, array, editMethod, deleteMethod) {
  let pRow = instance.toPhysicalRow(row)                       //When accessing original array
  let record = self[array][pRow];                //contractor = self.contractors[row]

  td.innerHTML = '<i class="fas fa-pen action-edit"></i><i class="fas fa-trash action-delete"></i>'
  td.style.verticalAlign = 'middle'
  td.style.textAlign = 'center'

  td.children[0].setAttribute('title', 'Edit ' + array);

  td.children[0].addEventListener('click', () => {
    self[editMethod](record, pRow);                   //self.onEditContractor(contractor)
  })

  if(deleteMethod){
    td.children[1].setAttribute('title', 'Delete ' + array);
    td.children[1].addEventListener('click', () => {
      self[deleteMethod](record.id, pRow);              //self.onDeleteContractor(contractor.id)
    })
  }else{
    td.children[1].style.display = 'none';
  }

  if(value === 'NA') td.innerHTML = ''
}

export const contractType = { 'ON_CONTRACT': 'On Contract', 'RENTED': 'Rented'}

export function getContractorStatusString(record){
  if(record.status) return 'Active'
  return 'Inactive'
}
